<div class="single-upload-file">
  <p-fileUpload
    #fileUpload
    name="image"
    (onSelect)="handleSelect($event)"
    [multiple]="false"
    customUpload="true"
    showUploadButton="false"
    showCancelButton="false"
    chooseLabel="Seleccionar imagen"
    accept="image/*"
    [previewWidth]="previewWidth"
    [maxFileSize]="maxFileSize"
    (onRemove)="handleRemove($event)">
    <ng-template pTemplate="file" let-files>
      <div
        class="flex align-items-center justify-content-between gap-4 font-light text-md">
        <div>
          <p-image
            imageClass="image-section"
            [src]="files.objectURL"
            alt="section"
            appendTo="body"
            width="150"
            [preview]="true" />
        </div>
        <div class="p-fileupload-filename">{{ files.name }}</div>
        <div class="white-space-nowrap">
          {{ fileUpload.formatSize(files.size) }}
        </div>
        <div>
          <ls-button-icon-atom [rounded]="true" severity="danger" size="small" (onClick)="fileUpload.remove($event, 0)">
            <span class="material-icons">delete</span>
          </ls-button-icon-atom>
        </div>
      </div>
    </ng-template>
  </p-fileUpload>
</div>
